import { prettifyPropName } from 'utils/recordDetailsUtils';

function DotLienLots({ lots }) {

	return lots.map((lot, i) => {
		return (
			<div className="mb-3" key={i}>
				<div className="mb-1"><strong>{`Block ${lot.block || '-'} / Lot ${lot.lot || '-'}`}</strong></div>
				{Object.keys(lot).map((key) => {
					let value = lot[key];
					return (
						<div key={key}>
							<span className="me-1">{prettifyPropName(key)}:</span>
							<span>{value || '-'}</span>
						</div>
					);
				})}
			</div>
		);
	});
}

export default DotLienLots;
